import axios from 'axios'
import {RecordSync} from './_constants'
import {RecordKeeperSourcePayload, SelectedFileOrFolderId} from './_models'
import {serialize} from '../../../core/_util'

const API_URL = process.env.REACT_APP_BASE_API_URL

const RECORD_KEEPER_SOURCE = `${API_URL}/recordskeeper/sources`
const CREATE_DEPARTMENT = `${API_URL}/recordskeeper/classifications`
const EDIT_DEPARTMENT = `${API_URL}/recordskeeper/classifications/update`
const GET_AI_EMAIL = `${API_URL}/recordskeeper/setting`
const CREATE_TEMPLATE = `${API_URL}/recordskeeper/reports/templates`
const CREATE_SCHEDULE_TEMPLATE = `${API_URL}/recordskeeper/reports/schedules`
const GET_TEMPLATES = `${API_URL}/recordskeeper/reports`
const CREATE_RECORD = `${API_URL}/recordskeeper/reports`
const GET_FILE_COUNT = `${API_URL}/recordskeeper/records/filecount`
const EXPORT_CSV = `${API_URL}/recordskeeper/report-export`
const GET_AUDITS = `${API_URL}/recordskeeper/audits/access`
const GET_ACTIVITY = `${API_URL}/recordskeeper/audits/activity`
const EXPORT_CSV_ACCESS_LOGS = `${API_URL}/recordskeeper/audits/export-access`
const EXPORT_CSV_ACTIVITY_LOGS = `${API_URL}/recordskeeper/audits/export-activity`
const DELETE_SCHEDULE = `${API_URL}/recordskeeper/reports`
const GET_FILE_RECORDS = `${API_URL}/recordskeeper/records/file`
const GET_META_DATA = `${API_URL}/recordskeeper/records`
const GET_FILE_ACTIVITY = `${API_URL}/recordskeeper/activity`
const GET_ACCESS_LOGS = `${API_URL}/recordskeeper/access`
const GET_LINKED_RECORDS = `${API_URL}/recordskeeper/records`
const GET_NOTIFICATION = `${API_URL}/recordskeeper/records/get-notifications`
const GET_LEVEL_FIVE = `${API_URL}/recordskeeper/classifications/five`
const CREATE_ACCESS_LOGS = `${API_URL}/recordskeeper/access`
const RECORD_N_FILES = `${API_URL}/recordskeeper/records/files`
const CREATE_RECIPIENT = `${API_URL}/recordskeeper/security/create`
const DELETE_SECURITY = `${API_URL}/recordskeeper/security`
const GET_COMPILANCE_LEGAL = `${API_URL}/recordskeeper/records/get-notifications`
const CREATE_SECURITY = `${API_URL}/recordskeeper/security`
const UPDATE_COMPILANCE_LEGAL = `${API_URL}/recordskeeper/records/update-notifications`
const CREATE_FILE_REQUEST = `${API_URL}/recordskeeper/requests-file`
const GET_FILE_REQUEST = `${API_URL}/recordskeeper/request-files/all`
const EDIT_FILE_REQUEST = `${API_URL}/recordskeeper/request-file`
const DELETE_FILE_REQUEST = `${API_URL}/recordskeeper/request-file`
const RECORD_PUBLIC_VIEW = `${API_URL}/recordskeeper/public-sharedLink`
const GET_PUBLIC_FILE_REQUEST = `${API_URL}/recordskeeper/public-request-file`
const CREATE_SHARE_DOCUMENT = `${API_URL}/recordskeeper/shareLink`
const GET_SHARE_DOCUMENT = `${API_URL}/recordskeeper/sharedLink`
const DELETE_FILE = `${API_URL}/recordskeeper/records`
const EXPORT_REQUEST_FILE = `${API_URL}/recordskeeper/export-request-file/all`
const GET_LEVEL_FOUR_FOLDER = `${API_URL}/recordskeeper/records/getListLevelFour`
const GET_MOVE_FILE = `${API_URL}/recordskeeper/records`
const GET_EMAIL_LIST = `${API_URL}/recordskeeper/records/get-team-members`
const CREATE_ACTIVITY = `${API_URL}/recordskeeper/activity`
const GET_EXPORT_ACTIVITY = `${API_URL}/recordskeeper/export-activity`
const GET_EXPORT_ACCESS = `${API_URL}/recordskeeper/export-access`
const RENAME_FOLDER = `${API_URL}/recordskeeper/classifications/update`
const RENAME_FILE = `${API_URL}/recordskeeper/records/file-version`
const RECORDS_KEEPER = `${API_URL}/recordskeeper/dashboard/stats`
const RECORDS_KEEPER_DATA_ACTIVITY = `${API_URL}/recordskeeper/data-activity`
const CHECK_ROLE = `${API_URL}/recordskeeper/security/role`
const CREATE_REQUEST_ACCESS = `${API_URL}/recordskeeper/access-request`
const UPDATE_REQUEST_ACCESS = `${API_URL}/recordskeeper/access-requests`
const UPDATE_FILE_REQUEST_ACCESS = `${API_URL}/recordskeeper/access/requests`
const GET_ALL_USERS = `${API_URL}/recordskeeper/reports/get-team-members`

const GET_STORAGE_UTILIZATION = `${API_URL}/recordskeeper/analytics/storage-utilization`
const GET_File_Types = `${API_URL}/recordskeeper/analytics/file-types`
const GET_EXPORT_SECURITY = `${API_URL}/recordskeeper/export-security`

const RECORDS_KEEPER_DOWNLOAD_FILE_COUNT = `${API_URL}/recordskeeper/file/download/count/`
const GET_SECURITy_EXPORT = `${API_URL}/recordskeeper/export-security`
const DOWNLOAD_REPORT = `${API_URL}/recordskeeper/report-download`
const ANALYTICS_STAT = `${API_URL}/recordskeeper/analytics-stat`
const DEPT_USER_WISE_ANALYTICS = `${API_URL}/recordskeeper/analytics/dept-user-wise`
const RECORD_ACCESS_REQUEST_ANALYTICS = `${API_URL}/recordskeeper/analytics/access-request`

const GET_ALL_CHAT_THREADS = `${API_URL}/rk-ai-chat-threads`
const CREATE_CHAT_THREADS = `${API_URL}/rk-ai-chats`
const GET_CHATS_FROM_THREAD = `${API_URL}/rk-ai-chat-threads`
const GET_PUBLIC_SELECTED_FILES = `${API_URL}/recordskeeper/ai/get-public-files`
const UPDATE_SHAREDLINK = `${API_URL}/recordskeeper/sharedLink/update`
const GET_RECENT_UPLOAD_FILE = `${API_URL}/recordskeeper/overview/view-all`
const GET_ALL_SEARCH_FILES = `${API_URL}/recordskeeper/all-files`
const GET_ALL_SYNCED_LOG_FILES = `${API_URL}/recordskeeper/synced-log-files`
const EXPORT_SYNCED_LOG_FILES = `${API_URL}/recordskeeper/synced-log-files/export`

export const createSourceSync = (payload: RecordKeeperSourcePayload, companyId: number) => {
  return axios.post(`${RECORD_KEEPER_SOURCE}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    timeout: 30000,
    validateStatus(status) {
      return true
    },
  })
}

export const updateSourceSync = (
  sourceId: string,
  payload: RecordKeeperSourcePayload,
  type: string,
  companyId: number
) => {
  return axios.post(`${RECORD_KEEPER_SOURCE}/${sourceId}?sourceName=${type}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getRecordKeeperSourceStorageFiles = (
  pageSize: number,
  nextPageToken: string | null,
  sourceName: RecordSync,
  sourceId: string,
  companyId: number,
  requestedFolderId: string | null
) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/${sourceId}?sourceName=${sourceName}&pageSize=${pageSize}${
      nextPageToken ? `&nextPageToken=${nextPageToken}` : ''
    }${requestedFolderId ? `&requestedFolderId=${requestedFolderId}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const selectedFilesToSyncRecordsKeeper = (
  sourceId: string,
  sourceName: RecordSync,
  selectedFileOrFolderId: SelectedFileOrFolderId,
  companyId: number,
  folderPath: string
) => {
  return axios.post(
    `${RECORD_KEEPER_SOURCE}/files?sourceId=${sourceId}&sourceName=${sourceName}`,
    {
      selectedFolderOrFileId: selectedFileOrFolderId.id,
      isFolder: selectedFileOrFolderId.isFolder,
      folderPath,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getAllSourcesList = async (companyId: number,isLocal?:boolean) => {
  return axios.get(`${RECORD_KEEPER_SOURCE}${isLocal ? '?isLocal=true' : ''}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const sourceSyncStatus = async (
  sourceId: string,
  status: boolean,
  sourceName: string,
  companyId: number
) => {
  return axios.post(
    `${RECORD_KEEPER_SOURCE}/${sourceId}/sync`,
    {
      sourceName,
      syncStatus: status,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteSourceApi = async (sourceId: string, companyId: number) => {
  return axios.delete(`${RECORD_KEEPER_SOURCE}/${sourceId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createDepartment = (
  companyId: number,
  payload: any,
  type: string,
  selectedDepartmentFolder?: string
) => {
  return axios.post(
    `${CREATE_DEPARTMENT}?type=${type}` +
      (selectedDepartmentFolder ? `&id=${selectedDepartmentFolder}` : ''),
    payload,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getClassification = (
  companyId: number,
  type: string,
  All: boolean,
  pageSize?: any,
  page?: any,
  selectedFolderLevel1?: string
) => {
  return axios.get(
    `${CREATE_DEPARTMENT}?type=${type}${pageSize ? `&pageSize=${pageSize}` : ''}${
      page ? `&page=${page}` : ''
    }&all=${All}${selectedFolderLevel1 ? `&id=${selectedFolderLevel1}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getRecordsFolder = (
  companyId: number,
  list: string[],
  type?: string,
  id?: string,
  year?: number | null,
  quarter?: string | null,
  month?: string | null,
  isFolderCountUpdate?: boolean
) => {
  return axios.get(
    `${RECORD_N_FILES}?list=${list.join(',')}${type ? `&type=${type}` : ''}${
      id ? `&id=${id}` : ''
    }${year || year === null ? `&year=${year}` : ''}${
      quarter || quarter === null ? `&quarter=${quarter}` : ''
    }${month || month === null ? `&month=${month}` : ''}${
      isFolderCountUpdate ? `&isFolderCountUpdate=${isFolderCountUpdate}` : ''
    }`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const deleteClassification = (companyId: number, id: string | null, type: string) => {
  return axios.delete(`${CREATE_DEPARTMENT}?id=${id}&type=${type}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const editDepartment = (companyId: number, id: string, payload: any, type: string) => {
  return axios.post(`${EDIT_DEPARTMENT}?type=${type}&id=${id}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getAiEmail = (companyId: number) => {
  return axios.get(`${GET_AI_EMAIL}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getRecords = (companyId: number) => {
  return axios.get(`${GET_FILE_COUNT}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getSourceReferenceData = (group: string, companyId: number) => {
  return axios.get(`${RECORD_KEEPER_SOURCE}/ref-data?group=${group}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createSettings = (companyId: number, payload: any) => {
  return axios.post(`${GET_AI_EMAIL}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createTemplate = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_TEMPLATE}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createScheduleTemplate = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_SCHEDULE_TEMPLATE}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const editScheduleTemplate = (companyId: number, payload: any, scheduleId: string) => {
  return axios.post(`${CREATE_SCHEDULE_TEMPLATE}?scheduleId=${scheduleId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getTemplates = (
  companyId: number,
  type: string,
  all: boolean,
  page?: number,
  pageSize?: number,
  selectedReportTypeFilter?: string,
  search?: string,
  id?: string
) => {
  const url = `${GET_TEMPLATES}?${type ? `type=${type}` : ''}${all ? `&all=${all}` : ''}${
    page !== undefined ? `&page=${page}` : ''
  }${pageSize !== undefined ? `&pageSize=${pageSize}` : ''}${
    selectedReportTypeFilter ? `&filterType=${selectedReportTypeFilter}` : ''
  }${search ? `&searchValue=${search}` : ''}${id ? `&id=${id}` : ''}`

  return axios.get(url, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createReport = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_RECORD}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const exportCSV = (companyId: number, type: string) => {
  return axios.get(`${EXPORT_CSV}?type=${type}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getAudits = (
  companyId: number,
  page?: number,
  pageSize?: number,
  search?: string,
  id?: string
) => {
  const url = `${GET_AUDITS}?${page !== undefined ? `page=${page}` : ''}${
    pageSize !== undefined ? `&pageSize=${pageSize}` : ''
  }${search ? `&search=${search}` : ''}${id ? `&id=${id}` : ''}`

  return axios.get(url, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getActivity = (
  companyId: number,
  page?: number,
  pageSize?: number,
  filter?: string
) => {
  const url = `${GET_ACTIVITY}?${page !== undefined ? `page=${page}` : ''}${
    pageSize !== undefined ? `&pageSize=${pageSize}` : ''
  }${filter ? `&filterType=${filter}` : ''}`

  return axios.get(url, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getFileActivity = (
  companyId: number,
  recordId: string,
  page?: number,
  pageSize?: number,
  filter?: string
) => {
  const url = `${GET_FILE_ACTIVITY}/${recordId}?${page !== undefined ? `page=${page}` : ''}${
    pageSize !== undefined ? `&pageSize=${pageSize}` : ''
  }${filter ? `&filterType=${filter}` : ''}`

  return axios.get(url, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getAccessLogs = (
  companyId: number,
  recordId: string,
  page?: number,
  pageSize?: number,
  search?: string
) => {
  const url = `${GET_ACCESS_LOGS}/${recordId}?${page !== undefined ? `page=${page}` : ''}${
    pageSize !== undefined ? `&pageSize=${pageSize}` : ''
  }${search ? `&search=${search}` : ''}`

  return axios.get(url, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateSecurityCompilance = (companyId: number, recordId: string, payload: any) => {
  return axios.post(`${UPDATE_COMPILANCE_LEGAL}/${recordId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createFileRequest = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_FILE_REQUEST}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getFileRequests = (
  companyId: number,
  page?: number,
  pageSize?: number,
  search?: string,
  selectedLevelTypeFilter?: string,
  selectedActionTypeFilter?: string
) => {
  const url = `${GET_FILE_REQUEST}?${page !== undefined ? `page=${page}` : ''}${
    pageSize !== undefined ? `&pageSize=${pageSize}` : ''
  }${search ? `&search=${search}` : ''}${
    selectedLevelTypeFilter ? `&levelType=${selectedLevelTypeFilter}` : ''
  }${selectedActionTypeFilter ? `&action=${selectedActionTypeFilter}` : ''}`
  return axios.get(url, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getEmailList = (companyId: number, recordId: string) => {
  return axios.get(`${GET_EMAIL_LIST}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getAllUsers = (companyId: number) => {
  return axios.get(`${GET_ALL_USERS}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getFileRequest = (companyId: number, requestedFileId: string) => {
  return axios.get(`${EDIT_FILE_REQUEST}/${requestedFileId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}
export const editFileRequest = (companyId: number, requestedFileId: string, payload: any) => {
  return axios.post(`${EDIT_FILE_REQUEST}/${requestedFileId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const deleteFileRequest = (companyId: number, fileId: string) => {
  return axios.delete(`${DELETE_FILE_REQUEST}/${fileId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getLinkedRecords = (
  companyId: number,
  recordId: string,
  page: number,
  pageSize: number
) => {
  return axios.get(
    `${GET_LINKED_RECORDS}/get-linked/${recordId}?page=${page}&pageSize=${pageSize}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const exportCSVAccessLogs = (companyId: number) => {
  return axios.get(`${EXPORT_CSV_ACCESS_LOGS}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const exportCSVActivityLogs = (companyId: number) => {
  return axios.get(`${EXPORT_CSV_ACTIVITY_LOGS}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getFileRecords = (companyId: number, classificationId: string) => {
  return axios.get(`${GET_FILE_RECORDS}/${classificationId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const deleteSchedule = (scheduleId: string, companyId: number, type: string) => {
  return axios.delete(`${DELETE_SCHEDULE}?type=${type}&id=${scheduleId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getMetaData = (companyId: number, recordId: string, selectedVersion?: string) => {
  return axios.get(
    `${GET_META_DATA}/${recordId}${selectedVersion ? `?fileVersionId=${selectedVersion}` : ''}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getNotifications = (companyId: number, recordId: string) => {
  return axios.get(`${GET_NOTIFICATION}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getClassificationLevelFive = (companyId: number, classificationId: string) => {
  return axios.get(`${GET_LEVEL_FIVE}/${classificationId}`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status) {
      return true
    },
  })
}

export const createAccess = (
  recordId: string,
  os: string,
  device: string,
  location: any,
  ipAddress: any,
  activity: string,
  companyId?: number,
  userId?: number
) => {
  if (companyId === undefined || companyId === null || userId === undefined || userId === null) {
    return axios.post(
      `${CREATE_ACCESS_LOGS}/${recordId}`,
      {
        os: os,
        device: device,
        location: location,
        ipAddress: ipAddress,
        activity: activity,
      },
      {
        validateStatus(status: any) {
          return true
        },
      }
    )
  } else {
    const headers = {
      'x-company-id': companyId,
      'x-id': userId,
    }
    return axios.post(
      `${CREATE_ACCESS_LOGS}/${recordId}`,
      {
        os: os,
        device: device,
        location: location,
        ipAddress: ipAddress,
        activity: activity,
      },
      {
        headers: headers,
        validateStatus(status: any) {
          return true
        },
      }
    )
  }
}

export const createRecipient = (companyId: number, recordId: string, payload: any) => {
  return axios.post(`${CREATE_RECIPIENT}/${recordId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getSecurityPermission = (
  companyId: number,
  recordId: string,
  page?: number,
  pageSize?: number,
  filter?: string
) => {
  const url = `${CREATE_SECURITY}/all/${recordId}?${page !== undefined ? `page=${page}` : ''}${
    pageSize !== undefined ? `&pageSize=${pageSize}` : ''
  }${filter ? `&type=${filter}` : ''}`

  return axios.get(url, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteSecurityPermission = (companyId: number, securityId: string | null) => {
  return axios.delete(`${DELETE_SECURITY}/${securityId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getCompilanceLegal = (companyId: number, recordId: string) => {
  return axios.get(`${GET_COMPILANCE_LEGAL}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getViewAndDownloadFile = (
  fileVersionId: string,
  companyId: number,
  isDownload?: boolean
) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperDownloadFile&fileVersionId=${fileVersionId}${
      isDownload ? `&isDownload=${isDownload}` : ''
    }`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getFileVersionsApi = (recordId: string, companyId: number) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperFileVersions&recordId=${recordId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getStructureClassificationLevel1Api = (companyId: number) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperStructureClassificationLevel1`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getStructureClassificationLevel2Api = (levelOneId: string, companyId: number) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperStructureClassificationLevel2&levelOneId=${levelOneId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getStructureClassificationLevel3YearApi = (companyId: number) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperStructureClassificationLevel3Year`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getStructureClassificationLevel3MonthApi = (companyId: number) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperStructureClassificationLevel3Month`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getStructureClassificationLevel4Api = (levelTwoId: string, companyId: number) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperStructureClassificationLevel4&levelTwoId=${levelTwoId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const updateMetadataApi = (fileVersionId: string, payload: any, companyId: number) => {
  return axios.post(`${DELETE_FILE}/file-version/${fileVersionId}/metadata`, payload, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status: any) {
      return true
    },
  })
}
export const getRecordPublicShareLink = (
  recordSharedId: string,
  passcode: string,
  email: string
) => {
  if ((email === undefined || email === '') && (passcode === undefined || passcode === '')) {
    return axios.get(`${RECORD_PUBLIC_VIEW}/${recordSharedId}`, {
      validateStatus(status) {
        return true
      },
    })
  } else if ((email !== undefined || email !== '') && (passcode === undefined || passcode === '')) {
    const headers = {
      'x-email': email,
    }
    return axios.get(`${RECORD_PUBLIC_VIEW}/${recordSharedId}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  } else if ((email === undefined || email === '') && (passcode !== undefined || passcode !== '')) {
    const headers = {
      'x-passcode': passcode,
    }
    return axios.get(`${RECORD_PUBLIC_VIEW}/${recordSharedId}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  } else {
    const headers = {
      'x-passcode': passcode,
      'x-email': email,
    }

    return axios.get(`${RECORD_PUBLIC_VIEW}/${recordSharedId}`, {
      headers: headers,
      validateStatus(status) {
        return true
      },
    })
  }
}

export const getRecordPublicFileRequest = (id: string, data?: any) => {
  return axios.post(`${GET_PUBLIC_FILE_REQUEST}/${id}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const createShareDocument = (companyId: number, recordId: string, payload: any) => {
  return axios.post(`${CREATE_SHARE_DOCUMENT}/${recordId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getSharedLink = (companyId: number, recordId: string) => {
  return axios.get(`${GET_SHARE_DOCUMENT}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const deleteFile = async (recordId: string, companyId: number) => {
  return axios.delete(`${DELETE_FILE}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getLevelFourFolder = (companyId: number) => {
  return axios.get(`${GET_LEVEL_FOUR_FOLDER}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}
export const moveFileToFolderFour = (companyId: number, recordId: string, levelFourId: string) => {
  return axios.get(`${GET_MOVE_FILE}/${recordId}/moveToRecord/${levelFourId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getRequestFileExportCsv = (companyId: number) => {
  return axios.get(`${EXPORT_REQUEST_FILE}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createActivityLog = (
  companyId: number,
  recordId: string,
  os: string,
  device: string,
  location: any,
  ipAddress: any,
  activity: string
) => {
  return axios.post(
    `${CREATE_ACTIVITY}/${recordId}`,
    {
      os: os,
      device: device,
      location: location,
      ipAddress: ipAddress,
      activity: activity,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getActivityFileExportCsv = (companyId: number, recordId: string) => {
  return axios.get(`${GET_EXPORT_ACTIVITY}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getSecurityPermissionExportCsv = (companyId: number, recordId: string) => {
  return axios.get(`${GET_EXPORT_SECURITY}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getAccessFileExportCsv = (companyId: number, recordId: string) => {
  return axios.get(`${GET_EXPORT_ACCESS}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createSourceFileToSync = (
  fileVersionId: string,
  sourceName: string,
  companyId: number
) => {
  return axios.post(
    `${RECORD_KEEPER_SOURCE}/files/version`,
    {
      fileVersionId,
      sourceName,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}
export const renameFolder = (
  companyId: number,
  recordId: string,
  currentFolderLevel: string,
  payload: {name: string}
) => {
  return axios.post(`${RENAME_FOLDER}?type=${currentFolderLevel}&id=${recordId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}
export const renameFile = (companyId: number, fileVersionId: string, payload: any) => {
  return axios.post(`${RENAME_FILE}/${fileVersionId}/metadata`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getLinkFilesApi = (
  recordId: string,
  companyId: number,
  selectedRecordsIds: string[]
) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperFilesToBeLinked&recordId=${recordId}&selectedRecordIds=${JSON.stringify(
      selectedRecordsIds
    )}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const deleteLinkedRecord = (fileLinkedId: string, companyId: number) => {
  return axios.delete(`${DELETE_FILE}/delete-linked?fileLinkedId=${fileLinkedId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getOverviewDataApi = (companyId: number) => {
  return axios.get(`${RECORDS_KEEPER}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getOverviewDataActivityApi = (companyId: number, selectedDataActivity: string) => {
  return axios.get(`${RECORDS_KEEPER_DATA_ACTIVITY}?filter=${selectedDataActivity}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const checkRole = (recordId: string, companyId: number, action: string) => {
  return axios.get(`${CHECK_ROLE}/${recordId}?action=${action}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const createAccessRequest = (payload: any, companyId: number, recordId: String) => {
  return axios.post(`${CREATE_REQUEST_ACCESS}/${recordId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getAccessRequest = (companyId: number, recordId: string) => {
  return axios.get(`${CREATE_REQUEST_ACCESS}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateAccessRequest = (companyId: number, requestAccessId: string, action: string) => {
  return axios.post(
    `${UPDATE_FILE_REQUEST_ACCESS}/${requestAccessId}`,
    {action: action},
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getAllFileRequests = (companyId: number) => {
  return axios.get(`${UPDATE_REQUEST_ACCESS}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateFileVersionDownloadCount = (fileVersionId: string) => {
  return axios.post(
    `${RECORDS_KEEPER_DOWNLOAD_FILE_COUNT}`,
    {
      fileVersionId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getStorageUtilization = (companyId: number) => {
  return axios.get(`${GET_STORAGE_UTILIZATION}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getFileTypes = (companyId: number) => {
  return axios.get(`${GET_File_Types}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getSecurityNPermissionFileExportCsv = (companyId: number, recordId: string) => {
  return axios.get(`${GET_SECURITy_EXPORT}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const downloadReport = (companyId: number, recordId: string) => {
  return axios.post(`${DOWNLOAD_REPORT}/${recordId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getFoldersLevel1AndLevel2Api = (companyId: number) => {
  return axios.get(`${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperFoldersLevelAndLevel2`, {
    headers: {
      'x-company-id': companyId.toString(),
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getAnalyticStat = (
  companyId: number,
  files: string | undefined,
  user: number | undefined
) => {
  const queryParams = []
  if (files) queryParams.push(`files=${files}`)
  if (user) queryParams.push(`user=${user}`)
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : ''

  return axios.get(`${ANALYTICS_STAT}${queryString}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getDeptUserWiseAnalytics = (
  companyId: number,
  type: 'dept' | 'user',
  selectedOptions: any[]
) => {
  return axios.get(
    `${DEPT_USER_WISE_ANALYTICS}?type=${type}${
      selectedOptions.length > 0
        ? `&selectedOptions=${selectedOptions.map((option) => option.value).join(',')} `
        : ''
    }`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getRecordKeeperUserListApi = (companyId: number,filterUserList?:boolean) => {
  return axios.get(`${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperUsersList${filterUserList ? '&filterUserList=true' : ''}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getRecordAccessRequest = (companyId: number, selectedOptions: any[]) => {
  return axios.get(
    `${RECORD_ACCESS_REQUEST_ANALYTICS}${
      selectedOptions.length > 0
        ? `?selectedOptions=${selectedOptions.map((option) => option.value).join(',')} `
        : ''
    }`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const rkGetAllChatThreads = (companyId: any) => {
  return axios.get(`${GET_ALL_CHAT_THREADS}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true // Accept all status codes
    },
  })
}

export const rkCreateChatThread = async (payload: any, companyId: any) => {
  return axios.post(`${CREATE_CHAT_THREADS}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true // Accept all status codes
    },
  })
}

export const rkGetChatsFromThread = (threadId: any, companyId: any) => {
  return axios.get(`${GET_CHATS_FROM_THREAD}/${threadId}/rk-ai-chats`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const rkUpdateChatThreadTitle = async (threadId: any, payload: any, companyId: any) => {
  return axios.post(`${GET_CHATS_FROM_THREAD}/${threadId}`, payload, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true // Accept all status codes
    },
  })
}

export const rkDeleteChatThread = async (threadId: any, companyId: any) => {
  return axios.delete(`${GET_CHATS_FROM_THREAD}/${threadId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const sendSelectedEmailsApi = (
  emailList: string,
  fileVersionIds: string[],
  companyId: number
) => {
  return axios.post(
    `${API_URL}/recordskeeper/ai/send-email`,
    {
      emailList,
      fileVersionIds,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getPublicSelectedFiles = (fileVersionIds: string, companyId: string) => {
  return axios.get(`${GET_PUBLIC_SELECTED_FILES}?fileVersionIds=${fileVersionIds}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const deleteSettings = (companyId: number, id: any, general: any) => {
  return axios.delete(`${GET_AI_EMAIL}/${id}/${general}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const updateSharedLink = (companyId: number, id: any, isActive: boolean) => {
  return axios.post(
    `${UPDATE_SHAREDLINK}/${id}`,
    {
      isActive: isActive,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const deleteSharedLink = (companyId: number, id: any) => {
  return axios.delete(`${UPDATE_SHAREDLINK}/${id}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getRecentUploadApi = (
  companyId: number,
  type: string,
  page?: number,
  pageSize?: number
) => {
  return axios.get(
    `${GET_RECENT_UPLOAD_FILE}?type=${type}${page ? `&page=${page}` : ''}${
      pageSize ? `&pageSize=${pageSize}` : ''
    }`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}
export const sourceRetryApi = (sourceId: string, companyId: number) => {
  return axios.get(
    `${RECORD_KEEPER_SOURCE}/ref-data?group=recordKeeperSyncRetry&sourceId=${sourceId}`,
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const getAllFiles = (
  companyId: number,
  page: number,
  size: number,
  fileNameSearch: string,
  sourceNameSearch: string,
  sourceTypeSearch: string,
  fileTypeSearch: string,
  maxSize: number | null,
  minSize: number | null,
  uploadedAfter: string,
  uploadedBefore: string,
  uploadedBy: number
) => {
  const object = {
    page,
    size,
    fileNameSearch,
    sourceNameSearch,
    sourceTypeSearch,
    fileTypeSearch,
    maxSize,
    minSize,
    uploadedAfter,
    uploadedBefore,
    uploadedBy,
  }
  return axios.get(`${GET_ALL_SEARCH_FILES}?${serialize(object)}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const getAllSyncedLogFiles  = (
  companyId: number,
  page: number,
  size: number,
  fileNameSearch: string,
  syncedStatusSearch: string,
  sourceNameSearch: string[],
  maxSize: number | null,
  minSize: number | null,
  syncedAfter: string,
  syncedBefore: string,
  uploadedBy: number[]
) => {
  const object = {
    page,
    size,
    fileNameSearch,
    sourceNameSearch,
    syncedStatusSearch,
    maxSize,
    minSize,
    syncedAfter,
    syncedBefore,
    uploadedBy,
  }
  return axios.get(`${GET_ALL_SYNCED_LOG_FILES}?${serialize(object)}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}

export const exportSyncedLogFiles = (
  companyId: number,
  fileNameSearch: string,
  syncedStatusSearch: string,
  sourceNameSearch: string[],
  maxSize: number | null,
  minSize: number | null,
  syncedAfter: string,
  syncedBefore: string,
  uploadedBy: number[]
) => {
  const object = {
    fileNameSearch,
    sourceNameSearch,
    syncedStatusSearch,
    maxSize,
    minSize,
    syncedAfter,
    syncedBefore,
    uploadedBy,
  }
  return axios.get(`${EXPORT_SYNCED_LOG_FILES}?${serialize(object)}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status: any) {
      return true
    },
  })
}
